var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 52,
    viewBox: "0 0 23 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.043 49.64C13.543 49.64 12.143 49.63 9.97299 49.63H6.06299V33.44C6.06299 18.12 5.89299 17.23 5.90299 17.24C5.92299 17.25 4.58299 17.51 3.38299 17.83C2.28299 18.13 1.10299 18.41 0.952992 18.45L0.542992 18.54L0.572992 14.14L0.582992 9.81997L0.912992 9.72996C1.19299 9.65996 7.17299 8.17998 12.763 6.89998C13.483 6.72998 13.763 6.66997 13.863 6.63997C13.913 6.62997 13.893 6.48996 13.893 6.40996C13.873 6.21996 13.873 5.99998 13.853 5.99998C13.823 6.00998 13.683 6.03996 13.523 6.07996C13.363 6.11996 10.373 6.82998 6.87299 7.64998C3.37299 8.48998 0.232992 9.28996 0.102992 9.32996C-0.0270082 9.44996 0.00299164 9.66998 0.00299164 14.3C0.00299164 17.13 0.0329918 19.27 0.0329918 19.27C0.102992 19.27 1.37299 18.98 2.73299 18.62C4.09299 18.26 5.23299 17.97 5.27299 17.97C5.31299 17.97 5.34299 25.23 5.34299 34.09V50.21H9.60299C12.403 50.21 13.653 50.18 14.043 50.16V49.64Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 51.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.402639dac5d1f58cfa27409bdf5c6e5e.svg";
export { ForwardRef as ReactComponent };